module.exports = __webpack_public_path__ + "img/lionel.95fa5e0e.jpg";